<template>
	<div
		class="container-fluid d-flex"
		style="
			width: 100vw;
			height: 100vh;
			justify-content: center;
			align-items: center;
		"
	>
		<div class="text-center">
			<i
				class="fa-duotone fa-circle-xmark mb-4"
				style="font-size: 5em"
			></i>
			<h4 class="mb-4">Ha ocurrido un error.</h4>
			<p>No se ha podido completar tu suscripción</p>
			<router-link
				v-if="this.currentUser"
				to="/membership/subscription"
				class="btn btn-fbo btn-lg my-3"
				>Continuar
			</router-link>
			<a
				v-else
				href="https://fundacionbertinosborne.org/"
				class="btn btn-fbo btn-lg my-3"
				>Continuar</a
			>
		</div>
	</div>
</template>

<script>
export default {
	name: "FailurePaymentView",
	components: {},
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.user.data;
		},
	},
	methods: {},
	mounted() {},
};
</script>
